export default {
  loading: false,
  loadingType: null,
  error: false,
  data: {
    bookingExcursions: {
      dataUrl: '/api/booking-excursions',
      submitUrl: '/api/update-excursions'
    },
    flights: {
      dataUrl: '/umbraco/api/tourdepartures/departuredetails'
    }
  },
  booking: {
    excursions: [],
  },
  holidays: [],
  paymentFrame: null,
  transId: null,
  paymentAmount: null,
  paymentSuccess: null,
  paymentError: false,
  cardTypeId: null,
  userDetails: {},
  tabsDisabled: false,
  hideCustomAmountOption: false,
  excursionAdded: false,
  errorMessage: null
};